var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 40 10",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.5014 9.5c3.5833 0 6.4984-2.01871 6.4984-4.50005s-2.9151-4.49995-6.4984-4.49995c-3.3894 0-6.1795 1.80637-6.4716 4.1018h-4.6771v-.9466h-22.35291362v2.68926h22.35301362v-.94648h4.6771c.2922 2.29554 3.0821 4.10202 6.4715 4.10202zm-12.0118-3.95161h-20.626521v-1.09678h20.626521zm6.3764-.54844c0-2.04217 2.5282-3.70355 5.6355-3.70355s5.6355 1.66138 5.6355 3.70355c0 2.04227-2.5282 3.70375-5.6355 3.70375s-5.6355-1.66148-5.6355-3.70375z",
    fill: "#dcca87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoon);
export default __webpack_public_path__ + "static/media/spoon.4a19e8ceb677bbbf6e8a52ae5b7c5baf.svg";
export { ForwardRef as ReactComponent };